var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalTwoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 72,
    viewBox: "0 0 32 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#43BF5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 21V20.0312L15.8828 15.8906C17.4062 14.3047 17.7578 13.6953 17.7578 12.7578V12.7422C17.75 11.5938 16.8828 10.7656 15.6562 10.7656C14.25 10.7656 13.2031 11.7344 13.2031 12.9453V12.9844H11.8438V12.9375C11.8438 10.9844 13.5312 9.53906 15.6328 9.53906C17.6719 9.53906 19.1641 10.9062 19.1641 12.6719V12.6875C19.1641 13.9219 18.5938 14.8516 16.5234 16.9688L13.8438 19.7188V19.75H19.3516V21H11.9141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalTwoGreen);
export default __webpack_public_path__ + "static/media/finalTwoGreen.609bddec6d36ea05407dfdee01ac22c8.svg";
export { ForwardRef as ReactComponent };